import { render, staticRenderFns } from "./_reports.vue?vue&type=template&id=21c986f0"
import script from "./_reports.vue?vue&type=script&lang=js"
export * from "./_reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports